import React, { useState, useEffect } from "react";
import "../../assets/css/video-mundial.css";

interface VideoMundialComponentProps {
  intro_title?: string;
  intro_video_link?: string;
  show_intro_video?: boolean;
}

const VideoMundialComponent: React.FC<VideoMundialComponentProps> = ({ 
  intro_title, 
  intro_video_link, 
  show_intro_video 
}) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    handleResize();
    window.addEventListener("resize", handleResize);
    
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  if (!show_intro_video) {
    return null;
  }

  const getYouTubeEmbedUrl = (url: string) => {
    const videoId = url.split('youtu.be/')[1]?.split('?')[0];
    if (!videoId) return url;
    return `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=0&loop=1&playlist=${videoId}`;
  };

  const videoUrl = intro_video_link ? getYouTubeEmbedUrl(intro_video_link) : "";

  const titleParts = intro_title ? intro_title.split('la Copa Mundial de la FIFA 2026™') : [];
  const titleFirstPart = titleParts[0] || "¿Te imaginas estar en";
  const titleSecondPart = "la Copa Mundial de la FIFA 2026™";

  return (
    <section className="video-mundial-section">
      <div className="video-mundial-container">
        <h2 className="video-mundial-title">
          {titleFirstPart}<br />{titleSecondPart}
        </h2>

        <div className={`video-mundial-wrapper ${isMobile ? "video-vertical" : "video-horizontal"}`}>
          <iframe
            width="100%"
            height="100%"
            src={videoUrl}
            title="Video promocional de la Copa Mundial de la FIFA 2026 y Hyundai"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default VideoMundialComponent;